import type { FC } from 'react';
import * as icons from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Badge, TBadge } from './badge';

type TSupportedIcons =
  | 'faCalendar'
  | 'faTachometerAlt'
  | 'faRoad'
  | 'faCarSide'
  | 'faGasPump'
  | 'faBolt'
  | 'faLeaf'
  | 'faCogs'
  | 'faArrowsSpin'
  | 'faMapMarkerAlt'
  | 'faKey'
  | 'faFileSignature'
  | 'faTag';

export type TFaIconBadgeBadge = Omit<TBadge, 'icon'> & { icon: TSupportedIcons };

type TBadgeList = {
  badges: TFaIconBadgeBadge[];
  variant?: TBadge['variant'];
  background?: TBadge['background']
};

export const ProposalBadgeList: FC<TBadgeList> = ({ badges, variant = 'md', background }) => {
  return (
    <ul className="flex flex-wrap gap-2">
      {badges.map(item => {
        const icon = icons[item.icon] || icons.faCar;

        return (
          <li key={item.label}>
            <Badge
              label={item.label}
              icon={<FontAwesomeIcon icon={icon} className="text-action/70" />}
              variant={variant}
              background={background}
            />
          </li>
        );
      })}
    </ul>
  );
};
